import React, { useId } from 'react';

export default function useSwiperHelpers({ spaceBetween = 0, slidesPerView = 1 }) {
  const randid = useId();

  const id = 'swiper-' + randid.replace(/:/g, '');
  const _breakpoints = { 0: { slidesPerView, spaceBetween } };
  const style = Object.entries(_breakpoints)
    .map(([key, value]) => {
      const { slidesPerView = 1, spaceBetween: gap = spaceBetween } = value;
      return `
       @media (min-width: ${key}px) {
          .${id}-slide { 
            width: calc((100% - ${(slidesPerView - 1) * gap}px) / ${slidesPerView});
            margin-right: ${gap}px;
          }            
        }`;
    })
    .join(' ')
    .replace(/\s+/g, ' ');

  const slideClass = id + '-slide';

  return { id, slideClass, style };
}
